<template>
  <div class="appointSetting">
    <el-card>
      <el-form :model="ruleForm" name="frm" ref="ruleForm" class="wid100" :label-width="require('@/config/enum').c_ws7"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem label="不可预约日期">
          <el-date-picker v-model="ruleForm.day" type="date" value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
          <el-checkbox-group v-model="ruleForm.checkList" style="display:inline-block; margin-left:20px;">
            <el-checkbox label="09:00:00-11:00:00">09:00:00-11:00:00</el-checkbox>
            <el-checkbox label="14:00:00-16:00:00">14:00:00-16:00:00</el-checkbox>
          </el-checkbox-group>
          <el-button style="margin-left:20px;" size="small" type="primary" @click="addDays">确定</el-button>
        </el-form-item>
        <el-form-item tem label="">
          <el-tag v-for="(tag,index) in ruleForm.dateTags" :key="index" closable @close="handleClose(tag)"
            style="margin-right:10px;">
            {{tag}}
          </el-tag>
        </el-form-item>
        <el-form-item tem label="每日预约上限（次）" prop="maxSecond">
          <el-input min=1 onkeyup="value=value.replace(/[^\d]/g,'')" v-model="ruleForm.maxSecond"
            placeholder="请输入每日预约上限" class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="接收预约短信手机号" prop="phoneNum">
          <el-input maxlength=11 onkeyup="value=value.replace(/[^\d]/g,'')" v-model="ruleForm.phoneNum"
            placeholder="请输入接收预约短信手机号" class="item-input"></el-input>
        </el-form-item>

        <!-- 按钮 -->
        <el-button class="detailbtn" type="primary" @click="save()">
          {{$t('lang.btn_save')}}
        </el-button>
        <el-form-item class="editor-height">
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:appointSetting
   *@Description:御琥阁预约设置
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  export default {
    data() {
      return {
        ruleForm: {
          id: '',
          checkList: [],
          day: '',
          dateTags: [], // 不可预约集合
          maxSecond: '', // 预约最大次数
          phoneNum: '', // 手机号码
        },
      }
    },
    created() {
      this.getData()
    },
    watch: {

    },
    methods: {
      // 时间戳转化日期
      timestampToTime(timestamp) {
        var date = new Date(timestamp) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear()
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
        let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
        return Y + '-' + M + '-' + D
      },
      // 获取数据
      getData() {
        let loading = this.$loading()
        this.$get(`/nSubSet`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.ruleForm.id = res.data.Id
              this.ruleForm.dateTags = res.data.NoSubDayList == null ? [] : res.data.NoSubDayList
              this.ruleForm.maxSecond = res.data.MaxSubOneDay
              this.ruleForm.phoneNum = res.data.SendPhone
              console.log(this.ruleForm)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 添加不可预约日期
      addDays() {
        let days = []
        if (this.ruleForm.day == '') {
          this.$message.error('请选择日期')
        } else if (this.ruleForm.checkList.length == 0) {
          this.$message.error('请选择时间段')
        } else {
          if (this.ruleForm.checkList.length == 1) {
            let arr1 = this.ruleForm.day + ' ' + this.ruleForm.checkList
            days.push(arr1)
          } else {
            for (let i = 0; i < this.ruleForm.checkList.length; i++) {
              let arr2 = this.ruleForm.day + ' ' + this.ruleForm.checkList[i]
              days.push(arr2)
            }
          }
          this.ruleForm.day = ''
          this.ruleForm.checkList = []
        }
        for (let j = 0; j < days.length; j++) {
          if (this.ruleForm.dateTags.indexOf(days[j]) == -1) {
            this.ruleForm.dateTags.push(days[j])
          }
        }
        console.log(this.ruleForm.dateTags)
      },
      // 删除不可预约日期
      handleClose(tag) {
        if (this.ruleForm.dateTags) {
          this.ruleForm.dateTags.splice(this.ruleForm.dateTags.indexOf(tag), 1)
        } else {
          this.ruleForm.dateTags = []
        }
      },
      // 保存
      save() {
        console.log(this.ruleForm.checkList)
        let loading = this.$loading()
        let params = {}
        params.id = this.ruleForm.id == undefined ? '' : this.ruleForm.id
        params.maxSubOneDay = this.ruleForm.maxSecond == 0 ? '' : this.ruleForm.maxSecond - 0
        params.noSubDay = (this.ruleForm.dateTags == undefined || this.ruleForm.dateTags == []) ? '' : this.ruleForm.dateTags.join(
          ',')
        params.sendPhone = this.ruleForm.phoneNum
        console.log(params)
        this.$post(`/nSubSet`, params).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.$message.success('保存成功')
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
    },
  }
</script>

<style lang="scss">
  .appointSetting {
    .item-input {
      width: 21%;
    }

    .el-date-editor.el-input {
      width: 21%;
    }
  }
</style>